<template>
    <div class="errors" v-if="errors.length > 0">
        <div class="ui divider"></div>
        <div class="ui red icon message">
            <i class="warning icon"></i>
            <div class="content">
                <div class="header">
                    <!-- 請處理以下錯誤 -->
                    {{ $t('ui.notifications.error.please_handle_errors') }}
                </div>
                <p v-for="(error, index) in errors">{{index + 1}}. {{error}}</p>
            </div>
        </div>
        <div class="ui divider"></div>
    </div>
</template>

<script>
export default {
    name: "ErrorBox",
    props: {
        errors: Array
    },
    data() {
        return {
        }
    },
    mounted() {
    },
    computed: {
    },
    methods: {
    },
    components: {
    }
}
</script>

<style scoped>
</style>
